import { render, staticRenderFns } from "./affiliationsTable.vue?vue&type=template&id=38fe9581"
import script from "./affiliationsTable.vue?vue&type=script&lang=js"
export * from "./affiliationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports